import { render, staticRenderFns } from "./planTorelease.vue?vue&type=template&id=4cf68e8f&"
import script from "./planTorelease.vue?vue&type=script&lang=js&"
export * from "./planTorelease.vue?vue&type=script&lang=js&"
import style0 from "./planTorelease.vue?vue&type=style&index=0&id=4cf68e8f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports